export const COLORBG2 = 'rgb(25, 25, 25);'
export const COLORBG1 = 'rgb(214, 27, 48);'
export const COLORTEXT = '#fff'
export const COLORTEXT2 = 'rgba(198, 201, 216, 0.75)'
export const COLORMY = '#f84617'
export const COLORMY2 = '#ff9999'
export const H1 ='3rem'
export const H2 = '1.5rem'
export const HT = '4rem'
export const FH1 = "'Anton', sans-serif;"
export const FH2 = "'Raleway'"


export const pokemonType =  {
    normal: '#A8A77A',
	fire: '#EE8130',
	water: '#6390F0',
	electric: '#F7D02C',
	grass: '#7AC74C',
	ice: '#96D9D6',
	fighting: '#C22E28',
	poison: '#A33EA1',
	ground: '#E2BF65',
	flying: '#A98FF3',
	psychic: '#F95587',
	bug: '#A6B91A',
	rock: '#B6A136',
	ghost: '#735797',
	dragon: '#6F35FC',
	dark: '#705746',
	steel: '#B7B7CE',
	fairy: '#D685AD',
}

